
      function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgDisclaimerIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18.23,
  height: 13.672,
  viewBox: "0 0 18.23 13.672"
}, props), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1764",
  d: "M23.764 968.365a.417.417 0 0 0-.065.013l-10.313 3.094H8.447a.414.414 0 0 0-.375.414v.544a2.617 2.617 0 0 0 0 5.119v.55a.414.414 0 0 0 .414.414h.66L8.1 981.478a.414.414 0 0 0 .388.557h2.072a.414.414 0 0 0 .388-.278l1.146-3.243h1.314L23.7 981.6a.414.414 0 0 0 .531-.395V968.78a.414.414 0 0 0-.466-.414zm-.363.971v11.307l-9.529-2.854v-5.6zM8.9 972.3h4.143v5.385H11.8a.414.414 0 0 0-.388.272l-1.146 3.249h-1.2l1.049-2.971a.414.414 0 0 0-.388-.55H8.9v-.414a.414.414 0 0 0-.317-.408 1.878 1.878 0 0 1 0-3.747.414.414 0 0 0 .317-.4z",
  style: {
    fill: "var(--theme-primary, #810ea9)"
  },
  transform: "translate(-6 -968.362)"
}));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"18.23\" height=\"13.672\" viewBox=\"0 0 18.23 13.672\">\r\n    <path data-name=\"Path 1764\" d=\"M23.764 968.365a.417.417 0 0 0-.065.013l-10.313 3.094H8.447a.414.414 0 0 0-.375.414v.544a2.617 2.617 0 0 0 0 5.119v.55a.414.414 0 0 0 .414.414h.66L8.1 981.478a.414.414 0 0 0 .388.557h2.072a.414.414 0 0 0 .388-.278l1.146-3.243h1.314L23.7 981.6a.414.414 0 0 0 .531-.395V968.78a.414.414 0 0 0-.466-.414zm-.363.971v11.307l-9.529-2.854v-5.6zM8.9 972.3h4.143v5.385H11.8a.414.414 0 0 0-.388.272l-1.146 3.249h-1.2l1.049-2.971a.414.414 0 0 0-.388-.55H8.9v-.414a.414.414 0 0 0-.317-.408 1.878 1.878 0 0 1 0-3.747.414.414 0 0 0 .317-.4z\" style=\"fill:var(--theme-primary, #810ea9)\" transform=\"translate(-6 -968.362)\"/>\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/DisclaimerIcon.17650a3953da9e522270dcecc88cc4c7.svg"),
        {
          React: SvgDisclaimerIcon,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      